/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard PRO React context
import { useSoftUIController } from "context";

function ActionCell({
  id,
  el,
  handleEditAction,
  handleDeleteAction,
  handleKeyAction,
  handleStatsKeyAction,
}) {
  const [keyTooltip, setKeyTooltip] = useState(null);
  const [statskeyTooltip, setStatsKeyTooltip] = useState(null);
  const [editable, setEditable] = useState(false);

  const [controller] = useSoftUIController();
  const { permissions } = controller;

  const copyKeys = (e, key, type) => {
    e.preventDefault();

    if (type == "apikey") {
      setKeyTooltip(key);
      handleKeyAction();
    }
    if (type == "statsapikey") {
      setStatsKeyTooltip(key);
      handleStatsKeyAction();
    }
  };

  useEffect(() => {
    if (
      permissions.length > 0 &&
      (permissions.indexOf("management-platforms-edit") > -1 || permissions.indexOf("super") > -1)
    ) {
      setEditable(true);
    }
  }, [permissions]);

  return (
    <SoftBox display="flex" alignItems="center">
      <SoftBox mx={2}>
        <SoftTypography
          variant="body1"
          color={keyTooltip ? "success" : "secondary"}
          sx={{ cursor: "pointer", lineHeight: 0 }}
          className={el.status == "Disabled" ? "select-disabled div" : ""}
          disabled={el.status == "Disabled"}
        >
          <Tooltip title={keyTooltip ? keyTooltip : "Copy ApiKey"} placement="top">
            <Icon
              onClick={(e) => (el.status == "Enabled" ? copyKeys(e, el.api_key, "apikey") : null)}
            >
              key
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftTypography
          style={{ fontSize: "0.45rem", padding: "0px", margin: "0px", lineHeight: "1" }}
          className={el.status == "Disabled" ? "select-disabled div" : ""}
          disabled={el.status == "Disabled"}
        >
          APIKEY
        </SoftTypography>
      </SoftBox>
      <SoftBox mx={2}>
        <SoftTypography
          variant="body1"
          color={statskeyTooltip ? "success" : "secondary"}
          sx={{ cursor: "pointer", lineHeight: 0 }}
          className={el.status == "Disabled" ? "select-disabled div" : ""}
          disabled={el.status == "Disabled"}
        >
          <Tooltip title={statskeyTooltip ? statskeyTooltip : "Copy StatsApiKey"} placement="top">
            <Icon
              onClick={(e) =>
                el.status == "Enabled" ? copyKeys(e, el.stats_api_key, "statsapikey") : null
              }
            >
              key
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftTypography
          style={{ fontSize: "0.45rem", padding: "0px", margin: "0px", lineHeight: "1" }}
          className={el.status == "Disabled" ? "select-disabled div" : ""}
          disabled={el.status == "Disabled"}
        >
          STATS
          <br />
          APIKEY
        </SoftTypography>
      </SoftBox>
      <SoftBox mx={2} sx={{ display: editable ? "" : "none" }}>
        <SoftTypography variant="body1" color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }}>
          <Tooltip title="Edit Platform" placement="top">
            <Icon onClick={handleEditAction}>{editable ? "edit" : "visibility_icon "}</Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>

      <SoftBox mx={2}>
        <SoftTypography
          variant="body1"
          color={
            el.user_template.length > 0
              ? el.user_template.find((item) => item.status == true)
                ? "secondary"
                : "secondary"
              : "primary"
          }
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            opacity:
              el.user_template.length > 0
                ? el.user_template.find((item) => item.status == true)
                  ? 1
                  : 0.5
                : 0.3,
          }}
        >
          <Tooltip
            title={
              el.user_template.length > 0
                ? el.user_template.find((item) => item.status == true)
                  ? "Enabled Template: " + el.user_template.find((item) => item.status == true).name
                  : "No Enabled Template Exist"
                : "None Template Exist"
            }
            placement="top"
          >
            <Icon>view_in_ar_outlined_icon </Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>

      <SoftBox mx={2} sx={{ display: handleDeleteAction ? "" : "none" }}>
        <SoftTypography variant="body1" color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }}>
          <Tooltip title="Delete Platform" placement="top">
            <Icon onClick={handleDeleteAction}>delete</Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props of the CreateTemplate
ActionCell.propTypes = {
  id: PropTypes.number,
  el: PropTypes.object,
  handleDeleteAction: PropTypes.func,
  handleEditAction: PropTypes.func,
  handleKeyAction: PropTypes.func,
  handleStatsKeyAction: PropTypes.func,
  handleSnapshotAction: PropTypes.func,
};

export default ActionCell;
